'use client'

import { useMemo } from 'react'
import { useRouter } from 'next/navigation'

export const beforeClientNavigation = 'vi:before-client-navigation'

// Programmatic navigation has no link click to cancel. Editors can subscribe
// while they contain unsent changes; otherwise this behaves like useRouter.
export function useGuardedRouter() {
  const router = useRouter()
  return useMemo(() => {
    const canNavigate = (href: string) =>
      window.dispatchEvent(
        new CustomEvent(beforeClientNavigation, {
          cancelable: true,
          detail: { href },
        })
      )
    return {
      ...router,
      push: (...args: Parameters<typeof router.push>) => {
        if (canNavigate(args[0])) router.push(...args)
      },
      replace: (...args: Parameters<typeof router.replace>) => {
        if (canNavigate(args[0])) router.replace(...args)
      },
    }
  }, [router])
}
